<template>
  <section class="bg-black contact-us">
    <!-- Desktop version Banner cover Section -->
    <div
      class="relative md:block hidden w-full overflow-hidden md:bg-center bg-no-repeat bg-right md:bg-contain contact-us-hero-bg-section h-[632px] sm:h-[750px] lg:h-[742px] 2xl:h-[820px] xl:block"
    >
      <div class="h-[480px] md:h-[497px] lg:h-[560px] xl:h-[740px]">
        <div class="container md:relative absolute top-[158px]">
          <div
            class="border-b-4 ml-0.5 md:border-b-[6px] skew-x-[-25deg] w-[106px]"
            style="border-color: #f1d4b5"
          />
          <h1
            class="text-[28px] mt-[47px] mb-0 lg:text-[44px] heading-text leading-[34px] xl:text-[52px] font-OPPO-sans-bold lg:leading-[52px] xl:leading-[58px] text-start text-white"
          >
            {{ $t("common.contact") }}
            <span class="lowercase text-primary">
              {{ $t("common.us") }}
            </span>
          </h1>
          <p
            class="text-[15px] md:text-base w-[299px] md:w-[450px] lg:w-[544px] font-OPPO-sans-regular !leading-[normal] font-light text-start text-white pt-[10px] md:pt-[37px]"
            v-html="
              $t('common.contact_us_description', {
                brand_name: 'Benda ',
                country_name: localeStore.defaultContryName,
                interpolation: { prefix: '[:', suffix: ']' },
              })
            "
          ></p>
        </div>
      </div>
    </div>
    <!-- Mobile Version Banner cover Section-->
    <ClientOnly>
      <div class="block lg:hidden md:hidden">
        <div class="relative" data-aos="fade-left" data-aos-delay="100">
          <img
            class="relative w-full h-[480px] object-cover object-top"
            src="@/assets/images/contact-us/contact-us-mobile-banner-img.png"
            alt=""
          />
        </div>
        <div
          class="flex bg-[#191919] items-center justify-start order-2 px-4 py-[60px] overflow-hidden md:w-1/2"
        >
          <div class="w-auto">
            <div
              class="border-b-4 w-[67px] border-[#f1d4b5] skew-x-[-25deg] flex justify-start items-start text-start h-1 lg:h-[6px] mb-[16px]"
            />
            <h1
              class="text-[28px] font-OPPO-sans-bold heading-text w-[345px] sm:w-full tracking-[-2%] leading-[36px] font-normal text-start text-white"
            >
              {{ $t("common.contact") }}
              <span class="lowercase text-primary">
                {{ $t("common.us") }}
              </span>
            </h1>
            <p
              class="text-[15px] xl:text-[20px] xl:leading-normal mt-[10px] text-white leading-[24px] font-OPPO-sans-regular font-light"
              v-html="
                $t('common.contact_us_description', {
                  brand_name: 'Benda ',
                  country_name: localeStore.defaultContryName,
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            ></p>
          </div>
        </div>
      </div>
    </ClientOnly>

    <!-- Contact Us form page -->
    <div class="grid w-full h-full grid-cols-1 overflow-hidden lg:grid-cols-5">
      <div
        class="flex w-full items-end justify-end col-span-3 py-[60px] md:py-[100px] px-[15px] md:px-[70px] bg-[#000]"
      >
        <div
          class="w-full lg:w-[518px] xl:w-[610px] 2xl:w-[658px] 3xl:w-[715px]"
        >
          <h2
            class="text-xl leading-5 text-white font-OPPO-sans-bold text-left sm:leading-[34px] sm:text-[26px]"
            v-text="$t('common.get_in_touch')"
          />

          <form
            id="contact_form"
            action="#"
            method="POST"
            class="grid grid-cols-1 col-span-2 gap-y-6 sm:grid-cols-2 sm:gap-x-8 mt-[30px]"
            @submit.prevent="onSubmit"
          >
            <div>
              <label
                for="contact_subject"
                class="block text-sm font-normal leading-5 text-white font-OPPO-sans-bold"
                v-text="$t('common.subject')"
              />
              <div class="mt-1.5">
                <select
                  id="contact_subject"
                  v-model="form.subject"
                  type="text"
                  :placeholder="$t('common.placeholder')"
                  name="subject"
                  class="font-OPPO-sans-regular font-normal text-base leading-[22px] border border-[#3C3C3C] bg-[#1F1F1F] text-white placeholder:text-[#A1A1A1] block w-full px-4 py-3 rounded-[2px] shadow-sm"
                  :class="{ 'is-invalid': errorsObj && errorsObj.subject }"
                  @input="clearValidation('subject')"
                >
                  <option
                    v-for="(subject, subjectIndex) in subjects"
                    :key="subjectIndex"
                    :value="$t(`common.${subject}`)"
                    v-text="$t(`common.${subject}`)"
                    class="text-black"
                  />
                </select>
                <p
                  v-if="errorsObj && errorsObj.subject"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.subject[0]"
                />
              </div>
            </div>
            <div v-if="store.country == 'int'">
              <!-- Country -->
              <div class="w-full">
                <label
                  for="country"
                  class="block text-sm font-normal leading-5 text-white font-OPPO-sans-bold"
                  v-text="$t('common.country')"
                />
                <div class="relative mt-1 rounded-md">
                  <div class="mt-1.5">
                    <vue-select
                      ref="select"
                      v-model="form.country_code"
                      :options="countries"
                      label="name"
                      class="shadow-sm vue-select-chooser"
                      :class="{
                        'is-invalid': errorsObj && errorsObj.country_code,
                      }"
                      :reduce="(country) => country.id"
                      :placeholder="$t('common.placeholder')"
                      @update:modelValue="clearValidation('country_code')"
                    >
                      <template #option="option">
                        <div class="flex items-center text">
                          <span class="text-gray-500">{{ option.flag }}</span>
                          <span class="ml-2">{{ option.name }}</span>
                        </div>
                      </template>
                    </vue-select>
                    <p
                      v-if="errorsObj && errorsObj.country_code"
                      class="mt-1 text-sm text-red-400"
                      v-text="errorsObj.country_code[0]"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label
                for="contact_given_name"
                class="block text-sm font-normal leading-5 text-white font-OPPO-sans-bold"
                v-text="$t('common.given_name')"
              />
              <div class="mt-1.5">
                <input
                  id="contact_given_name"
                  v-model="form.given_name"
                  data-cons-subject="given_name"
                  type="text"
                  :placeholder="$t('common.placeholder')"
                  name="given_name"
                  autocomplete="given-name"
                  class="ffont-OPPO-sans-regular font-normal text-base leading-[22px] border border-[#3C3C3C] bg-[#1F1F1F] !placeholder:text-[#A1A1A1] block w-full px-4 py-3 rounded-[2px] shadow-sm text-white"
                  :class="{ 'is-invalid': errorsObj && errorsObj.given_name }"
                  @input="clearValidation('given_name')"
                />
                <p
                  v-if="errorsObj && errorsObj.given_name"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.given_name[0]"
                />
              </div>
            </div>

            <div>
              <label
                for="contact_family_name"
                class="block text-sm font-normal leading-5 text-white font-OPPO-sans-bold"
                v-text="$t('common.family_name')"
              />
              <div class="mt-1.5">
                <input
                  id="contact_family_name"
                  :placeholder="$t('common.placeholder')"
                  v-model="form.family_name"
                  type="text"
                  data-cons-subject="family_name"
                  name="family_name"
                  autocomplete="family-name"
                  class="block w-full px-4 py-3 rounded-[2px] font-OPPO-sans-regular font-normal text-base leading-[22px] border border-[#3C3C3C] bg-[#1F1F1F] text-white !placeholder:text-[#A1A1A1] shadow-sm"
                  :class="{ 'is-invalid': errorsObj && errorsObj.family_name }"
                  @input="clearValidation('family_name')"
                />
                <p
                  v-if="errorsObj && errorsObj.family_name"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.family_name[0]"
                />
              </div>
            </div>

            <div>
              <label
                for="contact_email"
                class="block text-sm font-normal leading-5 text-white font-OPPO-sans-bold"
                v-text="$t('common.email')"
              />
              <div class="mt-1.5">
                <input
                  id="contact_email"
                  v-model="form.email"
                  data-cons-subject="email"
                  name="email"
                  type="email"
                  :placeholder="$t('common.placeholder')"
                  autocomplete="email"
                  class="font-OPPO-sans-regular font-normal text-base leading-[22px] border border-[#3C3C3C] bg-[#1F1F1F] !placeholder:text-[#A1A1A1] block w-full px-4 py-3 rounded-[2px] shadow-sm text-white"
                  :class="{ 'is-invalid': errorsObj && errorsObj.email }"
                  @input="clearValidation('email')"
                />
                <p
                  v-if="errorsObj && errorsObj.email"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.email[0]"
                />
              </div>
            </div>
            <div>
              <label
                for="contact_phone_number"
                class="block text-sm font-normal leading-5 text-white font-OPPO-sans-bold"
                v-text="$t('common.phone')"
              />
              <div class="relative z-30 mt-1 rounded-md">
                <client-only>
                  <VueTelInput
                    id="phone"
                    v-model="form.phone"
                    input-id="contact_phone_number"
                    mode="international"
                    autocomplete="phone"
                    :default-country="store.country"
                    :class="[
                      ' text-white  phone shadow-sm',
                      { 'is-invalid': errorsObj && errorsObj.phone },
                    ]"
                    :input-options="options"
                    @input="clearValidation('phone')"
                  />
                </client-only>
                <p
                  v-if="errorsObj && errorsObj.phone"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.phone[0]"
                />
              </div>
            </div>

            <div class="sm:col-span-2">
              <label
                for="contact_message"
                class="block text-sm font-normal leading-5 text-white font-OPPO-sans-bold"
                v-text="$t('common.message')"
              />
              <div class="relative mt-1">
                <textarea
                  id="contact_message"
                  v-model="form.message"
                  :placeholder="$t('common.placeholder')"
                  name="message"
                  rows="4"
                  class="font-OPPO-sans-regular font-normal text-base leading-[22px] border border-[#3C3C3C] bg-[#1F1F1F] placeholder:text-[#A1A1A1] block w-full px-4 py-3 rounded-[2px] shadow-sm min-h-40 text-white lg:min-h-32 max-h-64"
                  :class="{ 'is-invalid': errorsObj && errorsObj.message }"
                  @input="clearValidation('message')"
                />
                <p
                  v-if="errorsObj && errorsObj.message"
                  class="mt-1 text-sm text-red-400"
                  v-text="errorsObj.message[0]"
                />
                <!-- <span class="absolute h-6 text-xs leading-6 text-gray-600 end-1 -bottom-6" v-text="charactersLeft" /> -->
              </div>
            </div>
            <div class="sm:col-span-2">
              <label
                class="w-full py-2 text-sm text-white border border-transparent cursor-pointer contact--checkbox"
              >
                <input
                  id="contact_tos"
                  v-model="form.accept_terms"
                  type="checkbox"
                  class="me-3 cursor-pointer relative text-primary rounded-[2px] focus:ring-primary-500 focus:ring-2 mb-[.1rem] bg-transparent border-primary"
                  data-cons-preference="terms-and-conditions"
                  @input="clearValidation('accept_terms')"
                />
                <!-- eslint-disable vue/no-v-html -->
                <span
                  class="text-sm font-normal leading-7 terms contact__checkmark font-OPPO-sans-bold"
                  v-html="
                    $t('common.i_agree_with_the_terms_and_conditions').replace(
                      'legal',
                      $i18nPath(store.pageLinks['terms'])
                    )
                  "
                />
                <!-- eslint-enable -->
              </label>
              <p
                v-if="errorsObj && errorsObj.accept_terms"
                class="mt-1 text-sm text-red-400"
                v-text="errorsObj.accept_terms[0]"
              />
            </div>

            <div class="flex justify-center md:justify-start">
              <vue-hcaptcha
                ref="invisibleHcaptcha"
                size="invisible"
                :sitekey="$config.HCAPTCHA_SITE_KEY"
                theme="light"
                :language="store.locale"
                @verify="onVerify"
                @expired="onExpire"
                @challengeExpired="onExpire"
                @closed="onExpire"
                @error="onError"
              />
            </div>

            <div class="sm:col-span-2">
              <Btn
                id="contact_submit"
                type="submit"
                size="sm"
                block
                :rounded="false"
                class="text-sm rounded-[2px] uppercase"
                color="primary"
                :disabled="isSending"
              >
                <div class="flex items-center justify-center space-x-2">
                  <SpinnerIcon v-if="isSending" class="w-4 h-4 animate-spin" />
                  <span class="text-black uppercase font-OPPO-sans-bold">
                    {{ $t("common.submit") }}</span
                  >
                </div>
              </Btn>
            </div>
          </form>
        </div>
      </div>
      <!-- Global Contact option -->
      <div
        class="bg-[#1F1F1F] flex flex-col justify-start col-span-2 py-[60px] md:py-[100px] md:pl-[50px] px-[15px] md:pr-[70px]"
      >
        <div class="xl:w-[444px] w-full">
          <h2
            class="text-xl xl:w-[342px] w-full font-normal font-OPPO-sans-bold text-white leading-[34px] sm:text-[26px] capitalize-first"
            v-text="
              $t('common.contact_another_ways_to_contactus')
                .replace(':', '')
                .toLowerCase()
            "
          />

          <p
            class="text-[#A1A1A1] text-sm leading-[22px] font-normal mt-[14px] font-OPPO-sans-bold"
            v-html="$t('common.contact_us_chat_description')"
          />
          <div v-if="store.currentSiteSettings.intercom.integrate" class="mt-5">
            <NuxtLink to="#" class="w-full" @click.prevent="$intercom.show()">
              <span
                class="text-base font-normal leading-6 capitalize-first text-primary font-OPPO-sans-bold"
              >
                {{ $t("common.chat_now") }} >></span
              >
            </NuxtLink>
          </div>

          <ul
            class="divide-y divide-[#3C3C3C] border-y-[#3C3C3C] border-y mt-10"
          >
            <li v-if="currentSite?.phone" class="py-5">
              <span
                class="flex text-[#A1A1A1] text-sm leading-5 font-normal font-OPPO-sans-bold"
              >
                <PhoneIcon class="mr-1.5" /> {{ $t("common.phone") }}
              </span>
              <a
                :href="`tel:${phone}`"
                class="mt-2 no-underline hover:text-primary-500 hover:no-underline font-OPPO-sans-regular text-base md:text-lg leading-[26px] font-normal text-white"
              >
                {{ currentSite?.phone }}
              </a>
            </li>
            <li v-if="currentSite?.contact_email" class="py-5">
              <span
                class="flex text-[#A1A1A1] text-sm leading-5 font-normal font-OPPO-sans-bold"
              >
                <EmailIcon class="mr-1.5" /> {{ $t("common.email") }}
              </span>
              <a
                :href="`mailto:${currentSite.contact_email}`"
                class="mt-2 hover:no-underline hover:text-primary-500 no-underline font-OPPO-sans-regular text-base md:text-lg leading-[26px] font-normal text-white"
                >{{ currentSite?.contact_email }}
              </a>
            </li>
            <li v-if="currentSite?.address" class="py-5">
              <span
                class="flex text-[#A1A1A1] text-sm leading-5 font-normal font-OPPO-sans-bold"
              >
                <LocationIcon class="mr-1.5" /> {{ $t("common.address") }}
              </span>
              <a
                :href="`https://www.google.com/maps?q=${
                  currentSite?.address?.latitude
                },${currentSite?.address?.longitude} (${encodeURIComponent(
                  location
                )})`"
                target="_blank"
                rel="noopener noreferrer"
                class="mt-2 hover:no-underline hover:text-primary-500 no-underline font-OPPO-sans-regular text-base md:text-lg leading-[26px] font-normal text-white"
              >
                {{ location }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { VueTelInput } from "vue-tel-input";
import VueHcaptcha from "@hcaptcha/vue3-hcaptcha";
import SpinnerIcon from "~/assets/svg/spinner.svg?component";
import { useMainStore } from "@/store/index";
import { useTranslation } from "i18next-vue";
import { useLocaleStore } from "@/store/locales";
import PhoneIcon from "~/assets/svg/phone-solid.svg?component";
import LocationIcon from "~/assets/svg/location.svg?component";
import EmailIcon from "~/assets/svg/email.svg?component";

const store = useMainStore();
const nuxtApp = useNuxtApp();
const { t } = useTranslation();
const $i18nPath = nuxtApp.$i18nPath;
const $config = nuxtApp.$config.public;
const localeStore = useLocaleStore();
// const error = useError();
const route = useRoute();

const formFields = reactive({
  subject: t("common.general_enquiry"),
  given_name: "",
  family_name: "",
  email: "",
  phone: "",
  message: "",
  accept_terms: "",
  country_code: "",
  country_name: "",
});

let errorsObj = ref(null);
const countries = ref([]);
const invisibleHcaptcha = ref(null);

try {
  const { data } = await useAPI("api/front/countries");
  countries.value = data._rawValue ? data._rawValue.data : [];
} catch (e) {
  console.error(e);
  // error({ statusCode: 404 });
  throw createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
  });
}

const intercom = ref(
  typeof nuxtApp.$intercom !== "undefined" ? nuxtApp.$intercom : null
);

const subjects = ref(["general_enquiry", "marketing_and_sales"]);
let form = reactive(Object.assign({}, formFields));

const isSending = ref(false);
let options = reactive({
  placeholder: "(XXX) XXX - XX-XX",
  showDialCode: true,
});

const currentSite = computed(() => {
  return store.currentSite;
});

const phone = computed(() => {
  return currentSite?.value?.phone?.replace(/\D/g, "");
});

const location = computed(() => {
  const addr = currentSite.value?.address || {};
  const country = currentSite.value?.country || {};

  const parts = [
    addr.address1,
    addr.address2,
    addr.city,
    addr.state,
    country.name,
    addr.postal_code,
  ];

  return parts.filter(Boolean).join(", ") + ".";
});

// function charactersLeft () {
//   const char = this.form.message.length
//   const limit = 1000

//   return (limit - char) + ' / ' + limit
// }

function clearValidation(field) {
  switch (field) {
    case "subject":
      errorsObj.subject = null;
      break;
    case "given_name":
      errorsObj.given_name = null;
      break;
    case "first_name":
      errorsObj.first_name = null;
      break;
    case "accept_terms":
      errorsObj.accept_terms = null;
      break;
    case "phone":
      errorsObj.phone = null;
      break;
    case "email":
      errorsObj.email = null;
      break;
    case "message":
      errorsObj.message = null;
      break;
    case "country_code":
      errorsObj.country_code = null;
      break;

    default:
      break;
  }
}

function onVerify(token, ekey) {
  const defaultCountry = localeStore.defaultLocales.find(
    (_v) => _v.slug === store.country
  );
  form.company_id = defaultCountry ? defaultCountry.id : "";

  nuxtApp
    .$api("/api/front/contact", {
      method: "POST",
      body: {
        ...form,
        "h-captcha-response": token,
      },
    })
    .then((response) => {
      if (response.error) {
        errorsObj = response.error.value.cause._data.errors;
        nuxtApp.$toast.error(response.error.value.cause._data.message);
        isSending.value = false;
      } else {
        nuxtApp.$toast.success(t("common.contact_thanks"));

        form = Object.assign({}, formFields);
        form.phone = "";
        isSending.value = false;

        window._iub.cons_instructions.push([
          "submit",
          {
            writeOnLocalStorage: false,
            form: {
              selector: document.getElementById("contact_form"),
            },
            consent: {
              legal_notices: [
                {
                  identifier: "privacy_policy",
                },
                {
                  identifier: "cookie_policy",
                },
                {
                  identifier: "term",
                },
              ],
            },
          },
          {
            success(response) {
              // console.log(response)
            },
            error(response) {
              console.warning(response);
            },
          },
        ]);
      }
    })
    .catch((error) => {
      errorsObj = error._data.errors;
      console.log(error);
      nuxtApp.$toast.error(error._data.message);

      isSending.value = false;
    });
}

function onChangeCountry(event) {
  if (event) {
    form.country_code = event.id;
    form.country_name = event.name;
  }
}

function fillInAddress(event) {
  // Get the place details from the autocomplete object.
  const place = autocomplete.value.getPlace();
  let countryCode = "";
  let countryName = "";

  for (const component of place.address_components) {
    const componentType = component.types[0];

    switch (componentType) {
      case "country_code": {
        countryCode = component.country_code;
        break;
      }
      case "country_name": {
        countryName = component.country_name;
        break;
      }
    }
  }
}

function onExpire() {
  nuxtApp.$toast.error(t("Captcha expired"));

  console.log("[vue-htcapcha] Expired token");
  isSending.value = false;
}

function onError() {
  console.log("[vue-htcapcha] Failed to load hcaptcha");
  isSending.value = false;
}

function onSubmit() {
  if (isSending.value) {
    return;
  }

  isSending.value = true;
  errorsObj = {};
  if (invisibleHcaptcha.value) {
    invisibleHcaptcha.value.execute();
  }
}
</script>

<style lang="postcss">
@import "vue-tel-input/vue-tel-input.css";

.heading-text span {
  @apply text-primary;
}

.contact-us-hero-bg-section {
  background-image: url("@/assets/images/contact-us/contact-us-banner-img.png");
  background-repeat: no-repeat;
  background-position: center center;
  @apply md:bg-cover;
}
.contact-us .vue-select-chooser .vs__search::placeholder {
  @apply !text-opacity-40 text-white;
}
.contact-us
  .vue-select-chooser
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__selected {
  @apply !text-white opacity-100;
}
.contact--checkbox {
  .contact__checkmark {
    height: 17px;
    width: 17px;
    top: 0.2rem;
    left: 0;
    border-radius: 5px;

    &::after {
      content: "";

      @apply absolute hidden;
      top: 3px;
      left: 6px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
}
.contact-us .vti__dropdown-list.below {
  top: 47px;
}

.contact-us #phone {
  @apply h-12 w-full text-base leading-[22px] font-OPPO-sans-regular font-normal border-[#3C3C3C] bg-[#1F1F1F] placeholder:text-[#A1A1A1] rounded-[2px] text-white placeholder-current !important;
}

.contact-us .terms a {
  @apply !text-white;
}
.contact-us .terms a:hover {
  @apply !text-primary-500;
}

.vue-tel-input:focus-within {
  @apply shadow-none;
}
.contact-us #phone.vue-tel-input.is-invalid {
  @apply bg-transparent !border-red-500;
}
.vti__dropdown:focus,
.vti__input:focus {
  @apply ring-primary-500 border-primary-500 border-2;
}

.contact-us .vti__input {
  @apply border-[#3C3C3C] bg-[#1F1F1F]  text-white !important;
}

.contact-us .vue-tel-input:placeholder {
  @apply text-[#A1A1A1];
}

.contact-us .vti__dropdown {
  @apply rounded-e-none rounded-[2px] border-[#3C3C3C] border-r bg-[#1F1F1F] outline-none !important;
}
.contact-us .vue-select-chooser .vs__search {
  @apply m-0 px-[1rem];
}

.contact-us .vue-select-chooser .vs__actions {
  @apply pr-5;
}
.contact-us
  .vue-select-chooser
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__selected {
  @apply px-[1rem];
}

.contact-us .vti__dropdown-list {
  @apply text-black bg-white !important;
}

.contact-us .vue-select-chooser .vs__search::placeholder,
.contact-us .vue-select-chooser .vs__dropdown-toggle,
.contact-us .vue-select-chooser .vs__dropdown-menu {
  @apply mt-2 w-full rounded-[2px] text-base font-OPPO-sans-regular font-normal leading-[22px] border-[#3C3C3C] border !bg-[#1F1F1F] text-white placeholder:text-[#A1A1A1];
}

.contact-us .vue-select-chooser .vs__dropdown-menu {
  @apply w-[330px] overflow-x-hidden;
}

.vue-select-chooser .vs__dropdown-toggle {
  @apply bg-opacity-10 bg-white text-white h-[48px];
}

.vue-select-chooser .vs__dropdown-toggle .vs__selected-options .vs__selected {
  color: white;
  opacity: 0.7;
}

.vue-select-chooser .vs__dropdown-toggle:focus:focus {
  @apply focus:ring-primary-500 focus:border-primary-500 border-2;
}
</style>
